(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-collection"] && !Shopify.designMode) return;
  try {
    
function setupErColorForm(form) {
  if (form.dataset.erReady) return;
  form.dataset.erReady = 'true';
  form.addEventListener('submit', event => {
    event.preventDefault();
    const destination = new URL(form.querySelector('[data-er-color]').value, window.location.origin);
    if (destination.origin === window.location.origin) window.location.assign(destination.href);
  });
}
document.querySelectorAll('[data-er-color-form]').forEach(setupErColorForm);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-er-color-form]').forEach(setupErColorForm));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-consultation"] && !Shopify.designMode) return;
  try {
    
function setupErConsultation(root) {
  if (root.dataset.erReady) return;
  root.dataset.erReady = 'true';
  const params = new URLSearchParams(window.location.search);
  const requested = params.get('inquiry');
  if (root.querySelector('[data-er-success-message]')) {
    let submitted = requested;
    try { submitted = sessionStorage.getItem('er-inquiry-type') || requested; } catch (error) {}
    if (submitted === 'Sample purchase') {
      const copy = root.querySelector('[data-er-sample-success]').content;
      root.querySelector('[data-er-success-intro]').textContent = copy.querySelector('[data-key="intro"]').textContent;
      root.querySelector('[data-er-success-message]').textContent = copy.querySelector('[data-key="message"]').textContent;
    }
    return;
  }
  const type = root.querySelector('[data-er-type]');
  if (!type) return;
  const gift = root.querySelector('[data-er-gift]');
  function toggle(group, visible) {
    group.hidden = !visible;
    group.querySelectorAll('input, textarea').forEach(field => { field.disabled = !visible; });
  }
  function refresh() {
    const sample = type.value === 'Sample purchase';
    const copy = root.querySelector(sample ? '[data-er-sample-copy]' : '[data-er-default-copy]').content;
    root.querySelectorAll('[data-er-copy]').forEach(element => {
      element.textContent = copy.querySelector('[data-key="' + element.dataset.erCopy + '"]').textContent;
    });
    root.querySelector('textarea[name="contact[body]"]').required = !sample;
    root.querySelector('[data-er-garment]').required = sample;
    toggle(root.querySelector('[data-er-sample-fields]'), sample);
    toggle(root.querySelector('[data-er-gift-fields]'), gift.value === 'Yes');
    toggle(root.querySelector('[data-er-textile-fields]'), type.value === 'Heirloom textile');
  }
  if (Array.from(type.options).some(option => option.value === requested)) type.value = requested;
  const garment = params.get('garment');
  if (garment) root.querySelector('[data-er-garment]').value = garment.slice(0,200);
  type.addEventListener('change', refresh);
  gift.addEventListener('change', refresh);
  root.querySelector('form').addEventListener('submit', () => {
    try { sessionStorage.setItem('er-inquiry-type', type.value); } catch (error) {}
  });
  refresh();
}
document.querySelectorAll('[data-er-consultation]').forEach(setupErConsultation);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-er-consultation]').forEach(setupErConsultation);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-header"] && !Shopify.designMode) return;
  try {
    
function setupErHeader(root) {
  if (root.dataset.erReady) return;
  root.dataset.erReady = 'true';
  const menus = Array.from(root.querySelectorAll('details'));
  menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
    event.preventDefault();
    const opening = !menu.open;
    menus.forEach(other => { other.open = false; });
    menu.open = opening;
  }));
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const open = menus.find(menu => menu.open);
      if (open) { open.open = false; open.querySelector('summary').focus(); }
    }
  });
  document.addEventListener('click', event => {
    if (!root.contains(event.target)) menus.forEach(menu => { menu.open = false; });
  });
}
document.querySelectorAll('[data-er-header]').forEach(setupErHeader);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-er-header]').forEach(setupErHeader));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
